import { Alert, Stack, Text } from "@mantine/core";
import { ArrowLeft } from "lucide-react";
import type { ReactNode } from "react";

import { AuthSecondaryButton } from "../../ui/AuthShell";

export interface NotInvitedNoticeProps {
  /** The address that was refused, when the page knows it. */
  email?: string | undefined;
  /** A button or link back to the sign-in form. */
  action: ReactNode;
}

/**
 * NOT_INVITED: the email is verified but nobody invited it (D1). Created.ai is invite-only, so
 * the way forward is an invitation, or another address that has one.
 */
export function NotInvitedNotice({ email, action }: NotInvitedNoticeProps) {
  return (
    <Stack gap="sm">
      <Alert color="yellow" variant="light" role="alert" title="No invitation for this email">
        <Text size="sm">
          {email === undefined ? "This email" : <strong>{email}</strong>} has not been invited to a
          team yet. Created.ai is invite-only: ask a team admin to invite this address, then sign
          in again.
        </Text>
      </Alert>
      {action}
    </Stack>
  );
}

export function UseAnotherEmailButton({ onClick }: { onClick: () => void }) {
  return (
    <AuthSecondaryButton leftSection={<ArrowLeft size={20} />} onClick={onClick}>
      Use a different email
    </AuthSecondaryButton>
  );
}
